import { createApp, nextTick } from 'vue';
import ConfirmacionModal from '@/views/AlertasModal/ConfirmacionModal.vue';
import ErrorModal from '@/views/AlertasModal/ErrorModal.vue';
import WarningRegistroGoogle from '../views/AlertasModal/WarningGoogle.vue';
import * as bootstrap from 'bootstrap';

export const alertConfirmar = (mensaje) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const app = createApp(ConfirmacionModal, { mensaje });
  app.mount(container);

  nextTick(() => {
    const modalElement = document.getElementById('confirmacionModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false
      });

      modal.show();

      setTimeout(() => {
        modal.hide();
      }, 2500);

      modalElement.addEventListener('hidden.bs.modal', () => {
        app.unmount();
        container.remove();

        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) backdrop.remove();
        
        document.body.classList.remove('modal-open');
        document.body.style = '';
      });
    }
  });
};

export const alertError = (mensaje) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const app = createApp(ErrorModal, { mensaje });
  app.mount(container);

  nextTick(() => {
    const modalElement = document.getElementById('errorModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false
      });

      modal.show();

      setTimeout(() => {
        modal.hide();
      }, 2500);

      modalElement.addEventListener('hidden.bs.modal', () => {
        app.unmount();
        container.remove();

        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) backdrop.remove();
        
        document.body.classList.remove('modal-open');
        document.body.style = '';
      });
    }
  });
};



export const WarningGoogle = (mensaje) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const app = createApp(WarningRegistroGoogle, { mensaje });
  app.mount(container);

  nextTick(() => {
    const modalElement = document.getElementById('warningGoogleModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false
      });

      modal.show();

      modalElement.addEventListener('hidden.bs.modal', () => {
        app.unmount();
        container.remove();

        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) backdrop.remove();
        
        document.body.classList.remove('modal-open');
        document.body.style = '';
      });
    }
  });
};

export function showAlert(type, messages, duration = 5000) {
    // Mapeo de tipos personalizados
    const typeMap = {
        warning: "Cuidado",
        success: "Éxito",
        danger: "Error",
        info: "Información"
    };

    // Cambia el tipo de alerta por el texto personalizado
    const alertTypeText = typeMap[type] || type;

    // Elimina alertas anteriores
    const existingAlert = document.getElementById("custom-alert");
    if (existingAlert) existingAlert.remove();

    // Colores de borde según el tipo
    const borderColorMap = {
        warning: "border-warning",
        success: "border-success",
        danger: "border-danger",
        info: "border-info"
    };

       const colorMap = {
        warning: "#ffc107",
        success: "#198754",
        danger: "#dc3545",
        info: "#0dcaf0"
    };


    // Iconos según el tipo
    const iconMap = {
        warning: "⚠️",
        success: "✅",
        danger: "❌",
        info: "ℹ️"
    };

    // Crea el contenedor de la alerta
    const alertDiv = document.createElement("div");
    alertDiv.id = "custom-alert";
    alertDiv.className = `position-fixed top-50 start-50 translate-middle z-1050 custom-alert-card ${borderColorMap[type] || ''}`;
    alertDiv.style.cssText = `
        min-width: 300px;
        max-width: 500px;
        background: white;
        border-left: 4px solid;
        border-radius: 8px;
        box-shadow: 0 10px 25px rgba(0,0,0,0.15);
        padding: 1.5rem;
        transform: translate(-50%, -50%);
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
    `;

    // Crea el contenido de la alerta
    alertDiv.innerHTML = `<div class="text-center mb-3">
            <i class="${iconMap[type] || 'fa-solid fa-bell'} alert-icon" 
               style="font-size: 2.5rem; color: ${colorMap[type] || '#6c757d'};"></i>
        </div>
        <h5 class="text-center mb-3 fw-bold" style="color: ${colorMap[type] || '#6c757d'};">
            ${alertTypeText}
        </h5>
        <div class="alert-messages d-flex flex-column text-center">
            ${Array.isArray(messages) 
                ? messages.map(msg => `<div class="alert-message-item">${msg}`).join('</div>') 
                : `<div class="alert-message-item">${messages}</div>`
            }
        </div>
        <div class=" d-flex flex-column text-center mt-3">
            <button type="button" class="d-none btn btn-close btn-outline-${type}" aria-label="Close">
                Cerrar
            </button>
        </div>
    `;

    // Añade la alerta al documento
    document.body.appendChild(alertDiv);

    // Forzar reflow y luego mostrar con animación
    setTimeout(() => {
        alertDiv.style.opacity = "1";
    }, 10);

    // Configura el botón de cerrar
    const closeButton = alertDiv.querySelector('.btn-close');
    closeButton.addEventListener('click', () => {
        alertDiv.style.opacity = "0";
        setTimeout(() => alertDiv.remove(), 300);
    });

    // Cierra automáticamente después del tiempo definido
    if (duration > 0) {
        setTimeout(() => {
            if (document.body.contains(alertDiv)) {
                alertDiv.style.opacity = "0";
                setTimeout(() => alertDiv.remove(), 300);
            }
        }, duration);
    }
}

// Estilos CSS adicionales (puedes agregarlos a tu archivo CSS global)
const style = document.createElement('style');
style.textContent = `
    .custom-alert-card {
        animation: fadeInScale 0.3s ease-out;
    }
    
    @keyframes fadeInScale {
        from {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.9);
        }
        to {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
    }
    
    .custom-alert-card .btn-close {
        margin-top: -0.5rem;
        margin-right: -0.5rem;
    }
    
    .border-warning { border-left-color: #ffc107 !important; }
    .border-success { border-left-color: #198754 !important; }
    .border-danger { border-left-color: #dc3545 !important; }
    .border-info { border-left-color: #0dcaf0 !important; }
    
    .text-warning { color: #ffc107 !important; }
    .text-success { color: #198754 !important; }
    .text-danger { color: #dc3545 !important; }
    .text-info { color: #0dcaf0 !important; }
`;
document.head.appendChild(style);



